import { jsx as _jsx } from "react/jsx-runtime";
import "./bootstrap";
import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/inertia-react";
import { InertiaProgress } from "@inertiajs/progress";
const appName = window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => import(`./Pages/${name}`),
    setup({ el, App, props }) {
        createRoot(el).render(_jsx(App, { ...props }));
    },
});
InertiaProgress.init({ color: "#4B5563" });
